import { CreditCardEntryZoidComponent } from 'src/utilities/creditcard-iframe-types';
import {
  DataDogRumCorpContext,
  DataDogRumUser,
} from 'src/common/telemetry/DataDog/datadogRumApi';
import { isServerSide } from './isServerSide';

export type ExtendedGlobalContext = Partial<DataDogRumCorpContext> & {
  [key: string]: string | number | boolean | undefined | object;
};

export interface DurationVitalOptions {
  context?: Record<string, unknown>;
  description?: string;
}

export interface DurationVitalReference {
  __dd_vital_reference: true;
}
declare global {
  interface Window {
    ga: (eventType: string, eventBody: unknown) => void;
    DD_RUM?: {
      getGlobalContext: () => { global?: ExtendedGlobalContext };
      setGlobalContextProperty: (
        key: 'global',
        value: ExtendedGlobalContext
      ) => void;
      onReady(callback: () => void): void;
      setUser(user: DataDogRumUser): void;
      startDurationVital: (
        name: string,
        options?: DurationVitalOptions
      ) => DurationVitalReference;
      stopDurationVital: (
        nameOrRef: string | DurationVitalReference,
        options?: DurationVitalOptions
      ) => void;
    };
    URL: {
      createObjectURL: (object: Blob) => string;
    };
    $appVersions: unknown;
    ghsPayments?: {
      CreditCardEntryZoidComponent: CreditCardEntryZoidComponent;
    };
  }
}

export function getWindow(): Window {
  if (!isServerSide()) {
    return window;
  }
  return {} as Window;
}
